<template>
       <v-container fluid class="login">
          <v-layout flex justify-center>
            <v-flex  xs12 md4  v-if="this.isOS10">
              <v-card class="elevation-12 loginbody">
                <v-toolbar dark color="primary">
                  <img src="/img/logo.png" class="light-dark" alt="logo">
                  <v-spacer></v-spacer>
                </v-toolbar>
                 <v-form  v-model="valid" ref="form">
                   <span id="temp_breaks"><br></span>

                       <v-alert
                          color="error"
                          icon="warning"
                          v-show="submitted">
                           {{error}}
                        </v-alert>

                <v-card-text>
                      <v-text-field  v-model="username"  label="Username"  :rules="nameRules" required></v-text-field>
                      <!-- <div v-if="submitted && $v.username.$error" class="invalid-feedback">
                          <label v-if="!$v.username.required" class="error">This field is required.</label>

                     </div> -->

                      <v-text-field :type="'password'" label="Password" v-model="password"  :rules="passwordRules" required > </v-text-field>
                       <!-- <div v-if="submitted && $v.password.$error" class="invalid-feedback">
                          <label v-if="!$v.password.required" class="error">This field is required.</label>
                        </div>
                    -->
                </v-card-text>
                  <v-card-actions>

                    <v-btn color="primary" dark block  class="cus-button" @click="submit" :class="{ red: !valid, green: valid }">Log in</v-btn>

                  </v-card-actions>
               </v-form>
            </v-card>

            </v-flex>
            <v-flex xs12  v-else>
              <v-card>
                <v-card-text class="notfound">iPhone device, iOS 12 version or greater!</v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        <!--   <the-footer/> -->
       </v-container>
</template>

<script>
    import axios from 'axios';
    import TheFooter from "@/components/TheFooter";
    import { loginService } from '@/components/_service/Users.js';
    import { vapidKey } from '@/components/_service/Config.js';
    import { notificationservice} from '@/components/_service/Notification.js';
    const API_URL = process.env.API_URL || 'https://mobile.innity.com.my/apipost'
    //import ServiceWorkerStorage from 'serviceworker-storage';
    //const ServiceWorkerStorage = new ServiceWorkerServiceWorkerStorage('sw:storage', 1);
    import MobileDetect from 'mobile-detect';
    import * as localforage from "localforage";
 // import { required, minLength } from 'vuelidate/lib/validators'

 // import { loginService } from '@/_services/modules/Users.js'
  export default {
   components: {

     TheFooter
    },
    data(){
      return {
        valid: false,
        username : "",
        nameRules: [
          (v) => !!v || 'Username is required',

        ],
        password : "",
        passwordRules: [
              (v) => !!v || 'Password is required',
        ],
        submitted:false,
        error:"",
        loading:true,
        returnUrl: '',
         notificationsSupported: false,

        notificationsEnabled: false,
        buttonDisabled: false,
        serviceWorkerRegistation: null,
        subscription: null,
        isOS10:true,
        device:null,

      }
    },
    created () {

       let isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
          !window.MSStream;
        //  console.log(isIOS)
          if (isIOS){
            //);
            if (this.iOSVersion() < 11){
                this.isOS10 = false;
                // this.$router.push({ path: `/setting` })
              }

          }
          //var  navigator.userAgent; AppleWebKit/537.10+
          var str = navigator.userAgent;//navigator.userAgent;''

          var res = str.split(" ");
        //  console.log(res);
          var prefixPhone="";
          if (res[4]){
            prefixPhone =(res[3]+res[4] + res[5]);
            prefixPhone  = prefixPhone.replace("(","");
            prefixPhone  = prefixPhone.replace(")","");
          }

          var md = new MobileDetect(navigator.userAgent);
          var version = navigator.appVersion;
          let buildwedkit =  md.versionStr('Build');
          if (buildwedkit == null){
            buildwedkit =md.version('Webkit');
          }
          if (md.mobile()=='UnknownPhone'){
              this.device = res[4].replace(")","") +"-"+ md.os() +"-"+ buildwedkit +"-"+ prefixPhone;
          }else{
              this.device = md.mobile() +"-"+ md.os() +"-"+ buildwedkit +"-"+ prefixPhone;
          }


         // console.log( md );
         //console.log( md.userAgent() );

          //console.log( this.device );          // 'Sony'
       this.checkCurrentLogin()

    },
    beforeUpdate(){

    },
    mounted(){


         // 'Sony
     // console.log('dddddddd')
    },

    methods: {

        iOSVersion() {
              var match = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/),
                  version;

              if (match !== undefined && match !== null) {
                  version = [
                      parseInt(match[1], 10),
                      parseInt(match[2], 10),
                      parseInt(match[3] || 0, 10)
                  ];
                  return parseFloat(version.join('.'));
              }
              return false;
        },
        checkCurrentLogin () {

          // console.log(localStorage.getItem('token'))
            if (localStorage.getItem('token')) {
              this.$router.replace(this.$route.query.returnUrl || '/')
            }
         },
        checkUseronSub(usrId){
            return axios.post(`${API_URL}/push.php`, {
                  userId: usrId,
                  device: this.device,
                  axn:"userSub",
            }).then(function(result){
                return result.data;
            });

        },
        autoToggleSubscription(usrId){
        // console.log(this.notificationsEnabled)
          if (!('Notification' in window)) {
            console.log("This browser does not support notifications.");
          } else {
              if (!this.notificationsEnabled) {
                    // Ask permission and when granted, create new subscription
                    Notification.requestPermission()
                    .then(result => {
                        // if granted, create new subscription
                        if (result === 'granted') {
                           notificationservice.createSubscription(this.subscription)
                            .then(sub => {
                                console.log('auto subscription created on the client');
                                this.subscription = sub
                                this.fstCheck= true
                                let userId = usrId;
                                  //console.log(localStorage.token)
                                 if (localStorage.token !=null ){
                                   var strUser = atob(localStorage.token);
                                   var arrayUser = strUser.split(",");
                                   userId = arrayUser[0];
                                 }

                               // console.log('user created on the server', this.userId);
                                // store new subscription on the server
                                return axios.post(`${API_URL}/push.php`, {
                                    subscription: this.subscription,
                                    userId: userId,
                                    isSaleAccess:0,
                                    subscriber:'login',
                                    flightcount:0,
                                    camcount : 0,
                                    device: this.device,
                                    axn:"subscribe",
                                })
                            })
                            .then((result) => {

                               //
                                localforage.setItem('subscription',this.subscription.endpoint)
                                localforage.setItem('userId',usrId)
                                localforage.setItem('device',this.device )

                                this.notificationsEnabled = true
                                //this.fstCheck= false
                                notificationservice.showNotification()
                            })
                        } else {
                            //console.log('User did not granted permission')
                        }
                    })
            }
          }

       },
      async submit () {
            if (this.$refs.form.validate()) {
              const { username, password } = this;
              const { dispatch } = this.$store;
              let valueSubscription = null;
              if (localforage.getItem('subscription')){
                // console.log('ssssssssssss')
                  // const value = await localforage.getItem('subscription');
                  valueSubscription = await localforage.getItem('subscription');
              }

              this.$store.dispatch('login', { username, password })
               .then(() => {

                     notificationservice.findSubscription1()
                          .then(sub => {
                              let usrId = "";
                                  //console.log(localStorage.token)
                              if (localStorage.token !=null ){
                                 var strUser = atob(localStorage.token);
                                 var arrayUser = strUser.split(",");
                                 usrId = arrayUser[0];
                               }

                            //  console.log(sub +"ssssssss")
                              if (sub === null) {
                                  this.autoToggleSubscription(usrId);
                                  console.log('[mounted updated] no active subscription found on the client');
                                //  this.buttonDisabled = false
                                this.notificationsEnabled = false
                              } else {
                                  console.log('[mounted Login Page] Active subscription found ' + sub);
                                 // console.log(sub);
                                  this.notificationsEnabled = true
                                  this.subscription = sub
                                  if (valueSubscription == null){

                                      localforage.setItem('subscription',this.subscription.endpoint)
                                      localforage.setItem('device',this.device)

                                  }
                                  // retrieve user info from API
                                  var userSub = this.checkUseronSub(usrId);
                                  var promiseB = userSub.then(function(user) {
                                      //console.log(user);
                                      // check user have not subscribed;
                                      if (user.status === false){

                                        localforage.removeItem('subscription').then(function() {
                                            // Run this code once the key has been removed.
                                            console.log('subscription is cleared!');
                                        }).catch(function(err) {
                                            // This code runs if there were any errors
                                            console.log(err);
                                        });
                                     //   localforage.removeItem('subscription');
                                        localforage.removeItem('device');
                                        sub.unsubscribe();
                                      }
                                     // do something with result
                                  });


                              }
                    })
                  this.$router.push(this.$route.query.returnUrl || '/')
                  // console.log(arrayUser[0])
               }

                )
               .catch(err => {
                  this.submitted = true;
                  this.error = "Only sales person account is allow to login";

                  console.log(this.error )

               })
               .finally(() => this.loading = false)

              }
        },
    }
  }
</script>
